import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class HttpService {
  api: string;
  featureapi: string;
  npsUrl: string;

  constructor(private httpClient: HttpClient) {
    this.api = environment.apiUrl;
    this.featureapi = environment.apiUrl;
    this.npsUrl = environment.npsUrl;
  }

  sendGetRequest(npsUrl: any) {
    let finalUrl = this.npsUrl + npsUrl;
    return this.httpClient.get(finalUrl, this.get_httpoptions());
  }

  sendPostRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.post(finalUrl, data, this.get_httpoptions());
  }
  sendPostNPSRequest(npsUrl: any, data: any): Observable<Object> {
    let finalUrl = this.npsUrl + npsUrl;
    return this.httpClient.post(finalUrl, data, this.get_httpoptions());
  }

  sendPutRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.put(finalUrl, data, this.get_httpoptions());
  }
  sendPatchRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.patch(finalUrl, data, this.get_httpoptions());
  }
  sendUpdateRequest(apiUrl: any, data: any): Observable<Object> {
    let finalUrl = this.api + apiUrl;
    return this.httpClient.put(finalUrl, data, this.get_httpoptions());
  }
  sendDeleteRequest(npsUrl: any): Observable<Object> {
    let finalUrl = this.npsUrl + npsUrl;
    return this.httpClient.delete(finalUrl, this.get_httpoptions());
  }
  get_httpoptions(responseType?: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + localStorage.getItem('TOKEN')
      }),
      responseType: responseType || 'json' // Default to 'json' if responseType is not provided
    };
    return httpOptions
  }

    // Get id for support
    getSupport(id: any) {
        return this.httpClient.get(`${environment.apiUrl}/${id}`, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + localStorage.getItem('TOKEN')
            })
        })
    }

}

